<template>
  <div class="city">
    <area-cascader :level="0" type="text" v-model="city" :data="pca" ></area-cascader>
  </div>
</template>

<script>
import { pca, pcaa } from 'area-data'; // 城市数据
import 'vue-area-linkage/dist/index.css'; // 样式
export default {
  data() {
    return {
      city: [],
      pca: pca,
      pcaa: pcaa
    }
  },
  updated() {
    this.$emit('city', this.city)
  }
}
</script>

<style lang="less" type="text/less">
  .city{
    width: 100%;
    height: 100%;
    .area-cascader-wrap{
      width: 100%;
      height: 100%;
      .area-select{
        border:none !important;
        &.large{
          width: 100%;
          height: 100%;
          span{
            /*display: inline-block !important;*/
            width: auto !important;
            box-sizing: border-box;
            &.area-selected-trigger{
              line-height: 55px;
            }
          }
        }
        .area-select-icon{
          border-top-color:#666;
        }
      }
    }
  }



</style>



// WEBPACK FOOTER //
// src/components/City.vue